import { VigimareAlert } from '../../../models/vigimare-alert.model';

/**
 * Where an alert came from, which is not the same question as what it says.
 *
 * The feed merges stored history with the live stream, and the two are indistinguishable once they
 * are alerts — so anything that reacts to an alert *arriving*, rather than to it existing, has to
 * be told which is which. Without it, opening the page would announce every alert ever recorded.
 *
 * `updated` is its own case rather than being folded in with history: an alert the page already
 * has can still carry news, because a status change or an assignment arrives that way.
 */
export type CyberEventKind = 'history' | 'created' | 'updated';

/**
 * The single event shape the cyber page reduces over.
 *
 * The page is driven by alerts alone. Detection partners publish `VigimareAlert` messages
 * onto the `cyberAlerts` Kafka topic; the backend persists them and pushes them out over
 * the alert SSE stream, which is where these come from.
 */
export interface CyberEvent {
  at: string;
  alert: VigimareAlert;
  kind: CyberEventKind;
}

export function alertEvent(alert: VigimareAlert, kind: CyberEventKind = 'history'): CyberEvent {
  return { at: alert.generatedIn, alert, kind };
}
